import { z } from '@bonanza-social/toolkit/api';

const StatusSchema = z.enum([
  'Member',
  'Amethyst',
  'Topaz',
  'Aquamarine',
  'Opal',
  'Emerald',
  'Ruby',
  'Sapphire',
  'Diamond',
  'Vip',
]);

export const DailyRewardTypeSchema = z.enum([
  'DailyGift',
  'DailyWheel',
  'DailyScratcher',
]);

export const DailyRewardCurrencySchema = z.enum(['Coins', 'Tokens']).optional();

export const DailyRewardStatusSchema = z.enum([
  'Awarded',
  'Pending',
  'NotAvailable',
]);

export const DailyRewardLockedByStatusSchema = z.object({
  type: DailyRewardTypeSchema,
  status: z.literal('Locked'),
  availableAtLoyaltyStatus: StatusSchema,
});

export const DailyRewardSchema = z.object({
  type: DailyRewardTypeSchema,
  playerRewardId: z.number().optional(),
  rewardType: DailyRewardCurrencySchema,
  status: DailyRewardStatusSchema,
  expiryDate: z.string().datetime().optional(),
  nextAvailableAt: z.string().datetime().optional(),
  rewardAmount: z.number().optional(),
  isExternalReward: z.boolean().optional(),
});

export const DailyRewardItemSchema = z.union([
  DailyRewardLockedByStatusSchema,
  DailyRewardSchema,
]);

export const DailyRewardsResponseSchema = z.object({
  dailyRewards: z.array(DailyRewardItemSchema),
});
